import { Notification } from "./notification/notification";
import styled from "@emotion/styled";
import { useState } from "react";

const StyledAlertWrapper = styled(
    "div",
    {
        shouldForwardProp(propName: PropertyKey): boolean {
            return propName !== "showAlert";
        },
    }
)<{ showAlert: boolean }>(({ showAlert }) => ({
    transform: showAlert ? "scaleY(1)" : "scaleY(0)",
    transformOrigin: "top",
    transition: "transform .5s ease-in-out",
    overflow: "hidden",
}));

interface Props {
    fetchModuleData: () => { pending: number };
    isChannel: boolean;
    url: string;
}

export const CategoryNotificationCheckerInner = ({ fetchModuleData, isChannel, url }: Props) => {
    const [showAlert, setShowAlert] = useState(false);
    const { pending } = fetchModuleData();

    if (pending > 0) {
        setTimeout(() => setShowAlert(true));
    }

    // show message
    return (
        <StyledAlertWrapper showAlert={showAlert}>
            {showAlert && <Notification isChannel={isChannel} pending={pending} url={url} />}
        </StyledAlertWrapper>
    );
};

export default CategoryNotificationCheckerInner;
